import { render, staticRenderFns } from "./EntrepreneurParallaxLarge.vue?vue&type=template&id=bec3a4f4&"
import script from "./EntrepreneurParallaxLarge.vue?vue&type=script&lang=js&"
export * from "./EntrepreneurParallaxLarge.vue?vue&type=script&lang=js&"
import style0 from "./EntrepreneurParallaxLarge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports